import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/home/home"
import Navbar from './components/navbar/navbar';
import Footer from './components/footer/footer';
import Product from './pages/products/product';
import Problemimpact from "./pages/problemimpact/problemimpact";
import Sustainability from './pages/sustainability/Sustainability';
import Contactus from "./pages/contactus/contactus";
import BlogList from "./pages/BlogList";
import BlogDetail from "./pages/BlogDetail";
import Sitemap from "./pages/Sitemap";
import WhatsAppButton from './components/whatsapp/whatsapp';
import CookieConsentBanner from './components/CookieConsent';
import PageTracker from './components/PageTracker';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminBlogsList from './pages/admin/AdminBlogsList';
import AdminBlogEditor from './components/admin/AdminBlogEditor';
import AdminComments from './pages/admin/AdminComments';
import AdminSettings from './pages/admin/AdminSettings';
import AdminAnalytics from './pages/admin/AdminAnalytics';

const ProtectedAdminRoute = ({ children }) => {
  const { user, hasRole, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!user || !hasRole('admin')) return <AdminLogin />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <PageTracker />
      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/problemimpact" element={<Problemimpact />} />
        <Route path="/products" element={<Product/>} />
        <Route path="/sustainability" element={<Sustainability/>} />
        <Route path="/contact" element={<Contactus/>} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/sitemap.xml" element={<Sitemap />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<ProtectedAdminRoute><AdminLayout /></ProtectedAdminRoute>}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="blogs" element={<AdminBlogsList />} />
          <Route path="blogs/new" element={<AdminBlogEditor />} />
          <Route path="blogs/:id/edit" element={<AdminBlogEditor />} />
          <Route path="comments" element={<AdminComments />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="analytics" element={<AdminAnalytics />} />
        </Route>
      </Routes>
      {!isAdminRoute && <WhatsAppButton/>}
      {!isAdminRoute && <Footer/>}
      <CookieConsentBanner />
    </>
  );
}

export default App;
